import styled from '@emotion/styled';

export const StatusIndicatorWrapper = styled('div')`
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
`;
